package fr.manyverse.app.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import coil3.compose.SubcomposeAsyncImage
import coil3.compose.SubcomposeAsyncImageContent
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.character_avatar
import org.jetbrains.compose.resources.stringResource

@Composable
fun CharacterAvatar(
    imageUrl: String?,
    characterName: String,
    size: Dp = 64.dp,
    onClick: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    val clickableModifier = if (onClick != null) modifier.clickable(onClick = onClick) else modifier
    if (imageUrl != null) {
        SubcomposeAsyncImage(
            model = imageUrl,
            contentDescription = stringResource(Res.string.character_avatar, characterName),
            contentScale = ContentScale.Crop,
            modifier = clickableModifier
                .size(size)
                .clip(CircleShape)
        ) {
            SubcomposeAsyncImageContent()
        }
    } else {
        AvatarPlaceholder(characterName, size, clickableModifier)
    }
}

@Composable
private fun AvatarPlaceholder(
    characterName: String,
    size: Dp,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .size(size)
            .clip(CircleShape)
            .background(MaterialTheme.colorScheme.surfaceVariant),
        contentAlignment = Alignment.Center
    ) {
        Icon(
            imageVector = Icons.Filled.Person,
            contentDescription = stringResource(Res.string.character_avatar, characterName),
            tint = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.size(size * 0.6f)
        )
    }
}
